export default {
  zh: {
    topLovers:"Top Lovers",
  },
  ar: {
    topLovers:"اقوى العشاق",
    treeOfLovers:"شجرة الحب",
  },
  en: {
    topLovers:"Top Lovers",
    treeOfLovers:"Tree of Lovers",
  },
  tr: {
    topLovers:"En İyi Aşıklar",
    treeOfLovers:"Sevgi̇ler Ağaci",
    
  },
  uz:{
    topLovers: "Eng Yaxshi Sevuvchilar",
    treeOfLovers: "Sevuvchilar Daraxti"
},
    ru:{
    topLovers: "Топ Любовников",
    treeOfLovers: "Дерево Любовников"
},
    fa:{
    topLovers: "برترین عاشقان",
    treeOfLovers: "درخت عاشقان"
}



}



// WEBPACK FOOTER //
// src/pages/activity/valentineDay/lang.js